<template>
	<div class="page" style="background-image: url(./images/form_bg.png); background-size: cover; overflow: auto;">
		<img :src="'./images/exam_home.jpg'" style="width: 100%;" />

		<img :src="'./images/sichouqrcode.png'"
			style="width: 50%; border-radius: 40%; display: block; margin: 0 auto;" />

		<div style="text-align: center; line-height: 100px;">请扫描二维码或点击下方按钮开始登记</div>

		<div style="text-align: center; line-height: 50px;">
			<el-button type="primary">
				<a :href="wxurl" style="color: #fff; text-decoration: none;">开始登记</a>
			</el-button>
		</div>

	</div>
</template>

<script>
export default {
	data() {
		return {
			wxurl: "",
			agreed: 0,
			yinsi:false


		}
	},
	mounted() {

		document.title = "欢迎来到苏州丝绸中专"
		this.pmid = 12
		this.getUrl()

	},
	methods: {
		getUrl() {
			this.$http.post("/api/get_wxmini_weburl", { pmid: 20, t: "bk" }).then(res => {
				this.wxurl = res.data.openlink
			})
		},
		goYs() {

		}
	},
}
</script>
<style>
.yinsibox {
	position: fixed;
	width: 100vw;
	height: 100vh;
	z-index: 99;
	background: rgba(0, 0, 0, 0.6);
	top: 0;
}

.yinsicontain {
	width: 80%;
	padding: 5%;
	font-size: 14px;
	background-color: #fff;
	border-radius: 10px;
	margin: 0 auto;
	margin-top: 20vh;
}

.btn {
	display: inline-block;
	width: 100px;
	height: 30px;
	border: 1px solid #ccc;
	text-align: center;
	line-height: 30px;
	border-radius: 4px;
}

.btn:nth-child(2) {
	border: 1px solid #1283FF;
	background-color: #1283FF;
	color: #fff;
}
</style>
